import { render, staticRenderFns } from "./GetPatient.vue?vue&type=template&id=5de0ed3f&scoped=true&"
import script from "./GetPatient.vue?vue&type=script&lang=js&"
export * from "./GetPatient.vue?vue&type=script&lang=js&"
import style0 from "./GetPatient.vue?vue&type=style&index=0&id=5de0ed3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de0ed3f",
  null
  
)

export default component.exports